// eslint-disable-next-line @github-ui/github-monorepo/filename-convention
import { __zcFin, __zcFinZ, __zcMkv } from "__zod-compiler-runtime__";
import {BLOCKS, type Document} from '@contentful/rich-text-types'
import * as z from 'zod'

export const RichTextSchema: z.ZodType<Document> = /* @__PURE__ */ (() => {
var __zs=z.lazy(() =>
  z.object({
    nodeType: z.literal(BLOCKS.DOCUMENT),
    data: z.object({}),
    content: z.array(z.any()),
  }),
);
function __fc_1(input){return typeof input==="object"&&input!==null&&!Array.isArray(input)&&input["nodeType"]==="document"&&typeof input["data"]==="object"&&input["data"]!==null&&!Array.isArray(input["data"])&&Array.isArray(input["content"]);}
var __bf_2={};
function __vb_3(input){var __bv_4,__bv_5,__bo_6,__bv_7,__bo_9;if(typeof input!=="object"||input===null||Array.isArray(input))return __bf_2;__bv_4=input["nodeType"];if(!(__bv_4==="document"))return __bf_2;__bv_5=input["data"];if(typeof __bv_5!=="object"||__bv_5===null||Array.isArray(__bv_5))return __bf_2;__bo_6={};__bv_7=input["content"];if(!(Array.isArray(__bv_7)))return __bf_2;__bo_9={"nodeType":__bv_4,"data":__bo_6,"content":__bv_7};return __bo_9;}
var __rfm_z=__zs.safeParse;
function safeParse_RichTextSchema(input){
var __bd_10=__vb_3(input);
if(__bd_10!==__bf_2){return{success:true,data:__bd_10};}
return __zcFinZ(__rfm_z,__zs,input);
}
return __zcMkv(safeParse_RichTextSchema,__zs,null,__fc_1);
})()

export type RichText = z.infer<typeof RichTextSchema>
